// CheckoutForm.js
import React, { Component } from 'react';
import { unsubscribeStripe } from '../../store/actions/projectActions'
import { connect } from 'react-redux'
// import { addStripeToken } from '../../store/actions/projectActions'
import CancelModal from './CancelModal';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import VerifyEmail from '../layout/VerifyEmail';

M.AutoInit();


class CancelSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalShown: false,
    };
  }

  state = {
    clicked: false,
    plan: null,
    instance: null,
    isModalShown: false,
    sure: false

  }

  // componentDidMount() {
  //   const elem = this.exampleRef.current
  //   console.log(elem)
  //   const instance = M.Modal.getInstance(elem);
  //   console.log(instance)
  // };


  handleChange = (e) => {
    if (e.target.id === "sure") {
      this.setState({
        [e.target.id]: e.target.checked
      })

    } else {
      this.setState({
        [e.target.id]: e.target.value
      })
    }

  }



  handleSubmit = (auth, profile, plan) => e => {

    e.preventDefault();
    this.setState({ clicked: true })
    let promise = Promise.resolve();
    promise
      .then(() => {
        this.props.unsubscribeStripe()
      })
      .then(() => {
        this.setState({ isModalShown: true })
      })
      .catch((err) => {
        this.setState({ clicked: false })
        console.log(err)
      })
  };



  render() {
    const { auth, profile } = this.props

    if (!auth.uid) {
      return <Redirect to={'/signin'} />
    } else if (auth.uid && !profile.esign && profile.isLoaded) {
      return <Redirect to={'/mysign'} />
    }

    if (auth.emailVerified) {
      let currentplan

      let nextbutton

      if (!this.state.clicked) {
        if (profile.plan) {
          if (this.state.sure === true) {
            nextbutton = (
              <div className="input-field">
                <button className="btn red lighten-1 z-depth-0">UNSUBSCRIBE</button>
              </div>)
          } else if (this.state.sure === false) {
            nextbutton = (
              <div className="input-field">
                <button className="btn red lighten-1 z-depth-0" disabled>UNSUBSCRIBE</button>
              </div>)
          }
        } else if (profile.plan === null) {
          nextbutton = (
            <div>
            </div>)
        }
      }

      if (!profile.plan) {
        currentplan = "Free"
      } else if (profile.plan === 1) {
        currentplan = "Pro"
      } else if (profile.plan === 2) {
        currentplan = "Premium"
      }

      let switchform;
      if (currentplan === "Free") {
        switchform = (<div></div>)
      } else if (currentplan === "Pro" || currentplan === "Premium") {
        switchform = (
          <form onSubmit={this.handleSubmit(auth, profile, this.state.plan)} className="white">
            {/* <h5 className="grey-text text-darken-3">Unsubscribe Pro/Premium Account</h5> */}


            <div className="row">

              <div className="input-field">
                <p>
                  <label htmlFor="sure">
                    <input type="checkbox" id="sure" onChange={this.handleChange} />
                    <span>Are you sure you like to unsubscribe?</span>
                  </label>
                </p>
              </div>

              {nextbutton}
            </div>
          </form>
        )
      }

      return (

        < div className="grey lighten-5" >
          <div className="container">
            <div className="row"></div>
            <div className="row"></div>
            <div className="row"></div>
            <div className="row"></div>
            <h5 className="grey-text text-darken-3">Unsubscribe Pro/Premium Account</h5>

            <div className="row">
              Your current plan is {currentplan}</div>


            {switchform}
            {/* <form onSubmit={this.handleSubmit(auth, profile, this.state.plan)} className="white">


            <div className="row">

              <div className="input-field">
                <p>
                  <label htmlFor="sure">
                    <input type="checkbox" id="sure" onChange={this.handleChange} />
                    <span>Are you sure you like to unsubscribe?</span>
                  </label>
                </p>
              </div>

              {nextbutton}
            </div>
          </form> */}
          </div>

          {this.state.isModalShown &&
            <CancelModal onClose={() => {
              this.setState({ isModalShown: false })
              this.props.history.push('/dashboard')
            }} />
          }

        </div >
        // </div >

      );
    } else if (auth && !auth.emailVerified) {
      return (
        <VerifyEmail auth={auth} />
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    unsubscribeStripe: () => dispatch(unsubscribeStripe())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelSubscription);